<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px;margin: 0; margin-top: 5px;">
      <div style="padding: 10px 15px;border-bottom: 1px solid #eee;">
        <v-layout>
          <v-flex class="text-xs-left">
            <slot name="move"></slot>
          </v-flex>
          <v-flex class="text-xs-center">
            <v-btn
              outline
              color="primary"
              small
              class="ma-0"
              v-if="
                selectedBot.useketshop == true &&
                  selectedBot.ketshop_api_key &&
                  selectedBot.ketshop_api_secret
              "
              @click="onChangeMode"
            >
              <template v-if="!isProductview">{{ $t('Change to Menu List Format') }}</template>
              <template v-else>{{ $t('Change to Product Format') }}</template>

              <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <a href="javascript:void(0);" @click="onGenericChange(generic)">
              <v-icon small>delete</v-icon>
            </a>
          </v-flex>
        </v-layout>
      </div>
      <template>
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            :height="300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + vkey + '_image'"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile>
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_image') }"
          style="padding: 0 10px"
        >
          <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_image')">
            {{ errors.first('generic_manage_' + vkey + '_image') }}
          </span>
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_title') }"
            style="padding: 5px"
          >
            <textarea
              name="title"
              id="title"
              style="width: 100%;resize: none;height: 50px;font-weight: 600;"
              maxlength="80"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + vkey + '_title'"
              class="form-control"
              v-model="generic.title"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_title')">
              {{ errors.first('generic_manage_' + vkey + '_title') }}
            </span>
          </div>

          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_subtitle') }"
            style="padding: 5px"
          >
            <textarea
              name="subtitle"
              id="subtitle"
              style="width: 100%;resize: none;height: 70px;"
              maxlength="80"
              :data-vv-as="$t('Subtitle')"
              :data-vv-name="'generic_manage_' + vkey + '_subtitle'"
              class="form-control"
              v-model="generic.subtitle"
              :placeholder="$t('Enter Subtitle')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_subtitle')">
              {{ errors.first('generic_manage_' + vkey + '_subtitle') }}
            </span>
          </div>
        </div>
      </template>

      <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
        <template v-if="generic.buttons.length > 0">
          <li
            class="list-group-item"
            style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center"
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
          >
            <div style="padding: 10px 0;position:relative">
              {{ button.title }}
              <add-generic-button
                v-model="generic.buttons[bindex]"
                :key="'generic_button_' + bindex + '_' + editTimestamp"
                @onSave="editButton(bindex, $event)"
              >
                <span class="fa fa-pencil-alt"></span>
              </add-generic-button>
              <div style="position:absolute;right: 0;margin-right:0px; top: 0">
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small"
                  @click="deleteButton(bindex)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </template>
        <li
          v-if="generic.buttons.length < 3"
          class="list-group-item"
          style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;"
        >
          <div style="padding: 10px 0">
            <add-generic-button
              :key="'generic_button_new_' + saveTimestamp"
              v-model="newButton"
              @onSave="addNewButton"
            >
              <i class="fa fa-plus"></i>
              {{ $t('Add button') }}
            </add-generic-button>
          </div>
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/UploadFile'

import AddGenericButton from './AddGenericButton'
import moment from 'moment'

export default {
  inject: ['$validator'],
  components: {
    specialtext,
    uploadfile,
    AddGenericButton
  },
  props: {
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    vkey: {
      default: 0,
      type: [String, Number]
    }
  },
  data: function() {
    return {
      currentCategory: 'all',
      isProductview: false,
      generic: this.value,
      showModal: false,
      showProduct: false,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentProduct: null,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      search: '',
      filterBadge: undefined,
      editTimestamp: moment().format('x'),
      saveTimestamp: moment().format('x')
    }
  },
  mounted: function() {
    var vm = this
    if (vm.generic.productid) {
      vm.isProductview = true
    }
    delete vm.generic.enable
    if (vm.selectedBot.theme == 'ecommercebasic') {
      if (vm.generic.productid) {
        vm.currentProduct = vm.products.find(function(val) {
          return val.id == vm.generic.productid
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    filterProducts: function() {
      let vm = this

      let products = []
      vm.filterBadge = {
        all: vm.products.length,
        sales: 0,
        soldout: 0
      }

      $.each(vm.products, function(index, val) {
        if (parseFloat(val.price) > parseFloat(val.discountprice)) {
        }
        if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        } else {
          var isDiscount = false
          if (val.productstock) {
            val.productstock.map(function(stock, sindex) {
              if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                isDiscount = true
              }
            })
          }

          if (isDiscount) {
            vm.filterBadge.sales += 1
          }
        }
        if (vm.currentCategory === 'sales') {
          if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
            products.push(val)
          } else {
            if (val.productstock) {
              val.productstock.map(function(stock, sindex) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              products.push(val)
            }
          }
        } else if (vm.currentCategory === val.categoryid) {
          products.push(val)
        }
        if (val.productstock.length === 0) {
          vm.filterBadge.soldout += 1
          if (vm.currentCategory === 'soldout') {
            products.push(val)
          }
        } else {
          $.each(val.productstock, function(sindex, stock) {
            if (stock[2] <= 0) {
              vm.filterBadge.soldout += 1
              if (vm.currentCategory === 'soldout') {
                products.push(val)
              }
              return false
            }
          })
        }
      })
      if (vm.currentCategory === 'all') {
        products = vm.products
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter(product => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter(stock => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function() {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    onChangeMode: function() {
      if (this.$store.getters.getPackage != 'premium') {
        return false
      }
      if (this.isProductview == true) {
        delete this.generic.productid
      }
      this.isProductview = !this.isProductview
    },
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      $('.v-dialog').animate({
        scrollTop: 0
      })
    },
    onSelectProduct: function(product) {
      this.generic.productid = product.id
      this.currentProduct = product
      this.$emit('onSave', this.generic)
      this.showProduct = false
    },
    onSave: function() {
      this.$emit('onSave', this.generic)
    },
    onGenericChange: function(generic) {
      // generic.enable = !generic.enable
      this.$emit('onDelete')
    },
    addNewButton: function(payload) {
      if (this.generic.buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.generic.buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
      }
      this.saveTimestamp = moment().format('x')
    },
    editButton: function(index, payload) {
      if (this.generic.buttons[index]) {
        // this.generic.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.generic.buttons, index, payload)
      }
      this.editTimestamp = moment().format('x')
    },
    deleteButton: function(index) {
      this.generic.buttons.splice(index, 1)
    }
  },
  watch: {
    value: function() {
      this.generic = this.value
    },
    generic: function(newVal, oldVal) {
      // this.$emit('onSave')
    },
    search: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/flow/ManageGeneric.vue